const prefix = '/onlinecs/frequentlyKnowledge'

/**
 * 获取高频问答分析列表
 * @type {string}
 */
export const queryHighFrequencyPage = `${prefix}/queryFrequentlyKnowledgePage`

/**
 * 获取高频问答分析详情
 * @type {string}
 */
export const getHighFrequencyDetail = `${prefix}/getFrequentlyKnowledgeDetail`


/**
 * 批量导入场景分类
 * @type {string}
 */
export const batchImportSceneCategory = `${prefix}/batchImportSceneCategory`

/**
 * 下载场景分类模版
 * @type {string}
 */
export const downloadSceneCategoryTemplate = `${prefix}/downloadSceneCategoryModel`

/**
 * 导出高频问答分析列表
 * @type {string}
 */
export const downloadFrequentlyKnowledge = `${prefix}/downloadFrequentlyKnowledge`
